import { getShopifyProductId } from "../utils/metadata";

// Same visitor-id key + scheme the reviews widget uses, so PDP rating events
// correlate with the other Social Ocean storefront events for a visitor.
const VISITOR_ID_KEY = "socialocean_visitor_id";

export function generateUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getVisitorId(): string {
  if (typeof window === "undefined") return "";

  let visitorId = localStorage.getItem(VISITOR_ID_KEY);
  if (!visitorId) {
    visitorId = generateUUID();
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }
  return visitorId;
}

export type EventType =
  | "product_rating.prompt_shown"
  | "product_rating.star_selected"
  | "product_rating.submitted";

/**
 * Publish a storefront analytics event the same way the reviews widget does:
 * the payload carries { visitorId, url, productId, ...params } and the event
 * name is the `publish()` topic. The Social Ocean web pixel subscribes to the
 * topic, adds `event_type` + the Shopify client id, and forwards it to the
 * backend — so we must NOT put `event_type` in the payload here.
 */
export function trackEvent(eventType: EventType, params?: { rating?: number }) {
  try {
    if (!window.Shopify?.analytics?.publish) return;

    const visitorId = getVisitorId();
    if (!visitorId) return;

    const productId = getShopifyProductId();
    const url = window.location.href;

    const payload = { visitorId, url, productId, ...params };

    window.Shopify.analytics.publish(eventType, payload);
  } catch (error) {
    console.error("Failed to track event:", error);
  }
}
